module.exports = __webpack_public_path__ + "static/media/NeelakshiMukherjee.9d9f2811.jpg";